import { vehicleSituationTone, type VehicleSituationTone } from '@evogard/domain';
import type { CatalogStatus } from '@evogard/contract';

/**
 * A situação do carro na tela de quem atende — o selo e a moldura na cor que a
 * casa já julga (`vehicleSituationTone`). Mora aqui porque dois módulos a
 * desenham: a busca da Assistência 24h e a do aviso do Sinistro (03/11/2026).
 */

/** A moldura do cartão do carro na cor da situação — a mesma do selo. */
export const VEHICLE_SITUATION_FRAME: Record<VehicleSituationTone, string> = {
  erro: 'border-erro/50 bg-erro-suave',
  alerta: 'border-alerta/50 bg-alerta-suave',
  sucesso: 'border-sucesso/50 bg-sucesso-suave',
  neutro: 'border-borda bg-superficie-suave',
};

/**
 * A situação de um veículo do catálogo do ERP, no formato do selo.
 *
 * O código sem descrição aparece como código, e o que a casa não classificou
 * fica com a cor que só a descrição diz (verde para ATIVO, amarelo para
 * INADIMPLENTE, cinza o resto) — a cor avisa e não bloqueia (regra 14).
 */
export function catalogVehicleSituation(status: CatalogStatus): {
  label: string;
  tone: VehicleSituationTone;
} {
  const classified = status.estado === 'classificada' ? status : null;
  return {
    label: status.descricao ?? `Situação ${status.code}`,
    tone: vehicleSituationTone({
      label: status.descricao,
      canceled: classified?.canceled,
      deleted: classified?.deleted,
      blocksCancellation: classified?.blocksCancellation,
    }),
  };
}
